// ViaCEP (https://viacep.com.br) fills the address from the CEP in the Pix
// checkout (spec asaas-pix, D8). Only the CEP is sent. Any failure returns
// null and the member types the address.

const VIACEP_URL = "https://viacep.com.br/ws"
const VIACEP_TIMEOUT_MS = 4000

export const cepDigits = (value) => (value ?? "").replace(/\D/g, "").slice(0, 8)

export const formatCep = (value) => {
  const digits = cepDigits(value)
  return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits
}

/**
 * Looks up a CEP. Returns { street, neighborhood, city, state } or null when
 * the CEP is incomplete, unknown, or ViaCEP fails / takes too long.
 */
export async function lookupCep(cep, { fetchImpl, timeoutMs = VIACEP_TIMEOUT_MS } = {}) {
  const digits = cepDigits(cep)
  if (digits.length !== 8) return null

  const doFetch = fetchImpl ?? ((...args) => window.fetch(...args))
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)

  try {
    const res = await doFetch(`${VIACEP_URL}/${digits}/json/`, { signal: controller.signal })
    if (!res.ok) return null

    const data = await res.json()
    if (!data || data.erro) return null

    return {
      street: data.logradouro ?? "",
      neighborhood: data.bairro ?? "",
      city: data.localidade ?? "",
      state: data.uf ?? "",
    }
  } catch {
    return null
  } finally {
    clearTimeout(timer)
  }
}
